import { render, staticRenderFns } from "./MainTop.vue?vue&type=template&id=24b743ca&scoped=true"
import script from "./MainTop.vue?vue&type=script&lang=js"
export * from "./MainTop.vue?vue&type=script&lang=js"
import style0 from "./MainTop.vue?vue&type=style&index=0&id=24b743ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b743ca",
  null
  
)

export default component.exports